export default {"src":"/_next/static/media/redact-targeted-attacks-icon.b7a0b2bd.svg","height":40,"width":38,"blurWidth":0,"blurHeight":0};